package com.flowyride.core.api

import com.flowyride.core.domain.favorite.Favorite
import com.flowyride.core.domain.favorite.FavoriteException
import com.flowyride.core.domain.favorite.FavoriteSource
import com.flowyride.core.domain.favorite.FavoriteStop
import com.flowyride.core.domain.favorite.FavoriteSummary
import com.flowyride.core.domain.favorite.NewFavorite
import com.flowyride.core.domain.model.GeoPoint
import com.flowyride.core.domain.model.RouteEngineId

fun FavoriteSource.toDto() = FavoriteSourceDto.valueOf(name)

fun FavoriteSourceDto.toDomain() = FavoriteSource.valueOf(name)

fun FavoriteStop.toDto() = FavoriteStopDto(name, point.latitude, point.longitude)

/** @throws IllegalArgumentException on invalid coordinates. */
fun FavoriteStopDto.toDomain() = FavoriteStop(name, GeoPoint(lat, lon))

fun FavoriteSummary.toDto() = FavoriteSummaryDto(id, name, source.toDto(), distanceMeters, durationSeconds, createdAtEpochMillis)

fun FavoriteSummaryDto.toDomain() = FavoriteSummary(id, name, source.toDomain(), distanceMeters, durationSeconds, createdAt)

fun Favorite.toDto() = FavoriteDto(
    summary = summary.toDto(),
    stops = stops.map { it.toDto() },
    route = route.toDto(),
    preferences = preferences?.toDto(),
)

/** The route keeps the engine it was saved with (e.g. "gpx" for imported files). */
fun FavoriteDto.toDomain() = Favorite(
    summary = summary.toDomain(),
    stops = stops.map { it.toDomain() },
    route = route.toDomain(RouteEngineId(route.engine)),
    preferences = preferences?.toDomain(),
)

fun NewFavorite.toDto() = NewFavoriteDto(
    name = name,
    source = source.toDto(),
    stops = stops.map { it.toDto() },
    route = route.toDto(),
    preferences = preferences?.toDto(),
)

/** @throws IllegalArgumentException on invalid coordinates. */
fun NewFavoriteDto.toDomain() = NewFavorite(
    name = name.trim(),
    source = source.toDomain(),
    stops = stops.map { it.toDomain() },
    route = route.toDomain(RouteEngineId(route.engine)),
    preferences = preferences?.toDomain(),
)

fun ApiErrorDto.toFavoriteException(): FavoriteException = when (code) {
    ApiErrorCode.NOT_FOUND -> FavoriteException.NotFound()
    else -> FavoriteException.Invalid(message)
}
